import React from "react";
import { PopUpConstants, shared } from "../../src/taskpane/config/constants";
import { IAuthTokenResultDto } from "../../src/taskpane/interfaces/IAuthTokenResultDto";
import authModule, { DialogMessageResponse, DialogMessageStatus, TokenResource } from "../../utilities/AuthModule";
import { logger } from "../../utilities/logger";

export function useMailSendPopUpAuth() {
    const [isMailSendTokenAvailable, setIsMailSendTokenAvailable] = React.useState<boolean>(authModule.getPersistedAuthState()?.mailSendToken?.length > 0);
    const [isMailSendTokenRequestInProgress, setIsMailSendTokenRequestInProgress] = React.useState<boolean>(false);

    const authDialogRef = React.useRef<any>();

    const requestMailSendToken = () => {
        let authState: IAuthTokenResultDto = authModule.getPersistedAuthState();

        let authUrl: URL = new URL(`${process.env.baseUri}/auth.html`);
        authUrl.searchParams.append(shared.params.app, "content_manager");
        authUrl.searchParams.append(shared.params.resource, TokenResource.MailSend.toString());
        authUrl.searchParams.append(shared.params.username, authState.account?.username);
        /**
         * adding winLeft and winTop to account for dual monitor
         * using screenLeft and screenTop for IE8 and earlier
         */
        const winLeft = window.screenLeft ? window.screenLeft : window.screenX;
        const winTop = window.screenTop ? window.screenTop : window.screenY;
        /**
         * window.innerWidth displays browser window"s height and width excluding toolbars
         * using document.documentElement.clientWidth for IE8 and earlier
         */
        const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        const height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
        const left = Math.max(0, ((width / 2) - (PopUpConstants.POPUP_WIDTH / 2)) + winLeft);
        const top = Math.max(0, ((height / 2) - (PopUpConstants.POPUP_HEIGHT / 2)) + winTop);

        authDialogRef.current = window.open(authUrl.href, `${PopUpConstants.POPUP_NAME_PREFIX}.${TokenResource.MailSend}`, `width=${PopUpConstants.POPUP_WIDTH}, height=${PopUpConstants.POPUP_HEIGHT}, top=${top}, left=${left}, scrollbars=yes`);
    }

    const processAuthDialogResponse = (event) => {
        if (event.origin != process.env.baseUri)
            return;

        try {
            if (event.data) {
                const messageFromDialog: DialogMessageResponse = event.data;
                if (messageFromDialog?.status === DialogMessageStatus.Success) {
                    if (messageFromDialog.result?.mailSendToken?.length > 0) {
                        let authState: IAuthTokenResultDto = authModule.getPersistedAuthState();                        
                        if (authState) {
                            authState.mailSendToken = messageFromDialog.result.mailSendToken;
                            authState.mailSendTokenExpiresOn = messageFromDialog.result.mailSendTokenExpiresOn;
                            authModule.persistAuthState(authState);
                            setIsMailSendTokenAvailable(true);
                        }
                    }
                }
            }
        } catch (error) {
            logger(error, "useMailSendPopUpAuth.tsx (processAuthDialogResponse)", event.data);
        }

        authDialogRef?.current?.close();
    }

    React.useEffect(() => {
        window.addEventListener("message", processAuthDialogResponse);
        if (!isMailSendTokenAvailable) {
            (async () => {
                setIsMailSendTokenRequestInProgress(true);
                const mailSendToken: string = await authModule.getMailSendAccessToken(true);
                if (mailSendToken) {
                    setIsMailSendTokenAvailable(true);
                }
                setIsMailSendTokenRequestInProgress(false);
            })();
        }
        return () => window.removeEventListener("message", processAuthDialogResponse);
    }, [isMailSendTokenAvailable]);

    return { isMailSendTokenAvailable, isMailSendTokenRequestInProgress, requestMailSendToken }
}